window.Sparkle ??= {};

Sparkle.AssetLibrary = class AssetLibrary {
  constructor(endpoint, options) {
    this.render = this.render.bind(this);
    this.renderAssets = this.renderAssets.bind(this);
    this.renderAsset = this.renderAsset.bind(this);
    this._handleAssetSelected = this._handleAssetSelected.bind(this);
    this.query = this.query.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.setParams = this.setParams.bind(this);
    this._fetchAndRender = this._fetchAndRender.bind(this);
    this._debounce = this._debounce.bind(this);
    this._fetch = this._fetch.bind(this);
    this._setResults = this._setResults.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    this.endpoint = endpoint;
    if (options == null) {
      options = {};
    }
    this.options = options;
    this.el = jQuery('<div class="asset-library">');
    this.querying = jQuery('<span class="message querying-message">Searching...</span>');
    this.noMatches = jQuery('<span class="message no-matches-message">No Matches</span>');

    this.setParams(this.options.params);
    this.options = jQuery.extend(
      {
        debounce: 0,
        blankQueries: false,
      },
      this.options,
    );

    // BEHAVIOUR

    this.el.on("click", ".asset", this._handleAssetSelected);
  }

  render() {
    if (this.results) {
      this.el.html(this.renderAssets(this.results));
    } else {
      this.el.html(this.querying);
      this._fetchAndRender();
    }

    return this;
  }

  renderAssets(assetsJSON) {
    if (assetsJSON.length) {
      return jQuery.map(assetsJSON, (assetJSON) => this.renderAsset(assetJSON));
    } else {
      return this.noMatches;
    }
  }

  renderAsset(assetJSON) {
    const thumbnail = jQuery('<img class="thumbnail">').attr("src", assetJSON.thumbnail_url);
    const filename = jQuery('<span class="filename">').text(assetJSON.label);
    return jQuery('<span class="asset">').data("asset-json", assetJSON).append(thumbnail, filename);
  }

  // EVENT HANDLERS

  _handleAssetSelected(event) {
    const element = jQuery(event.target).closest(".asset");
    return this._triggerEvent("select", element.data("asset-json"), element);
  }

  // DSL

  query(query) {
    this.setQuery(query);
    return this.render();
  }

  setQuery(query) {
    return this.setParams({ query });
  }

  setParams(options) {
    this._setResults(null);
    return (this.options.params = {
      ...this.options.params,
      ...options,
    });
  }

  // HELPER FUNCTIONS

  _fetchAndRender() {
    return this._debounce("fetch", this.options.debounce, () => {
      if (!this.options.params.query && !this.options.blankQueries) {
        return;
      }

      return this._fetch().done((assetsJSON) => {
        this.el.empty();
        this.el.html(this.renderAssets(assetsJSON));
        return this._triggerEvent("update", assetsJSON);
      });
    });
  }

  _debounce(namespace, delay, fn) {
    if (this.debounces == null) {
      this.debounces = {};
    }
    if (this.debounces[namespace]) {
      clearTimeout(this.debounces[namespace]);
    }
    return (this.debounces[namespace] = setTimeout(fn, delay));
  }

  _fetch() {
    const params = {
      ...this.options.params,
    };
    const promise = jQuery.get(this.endpoint, params);
    promise.done((assetJSON) => this._setResults(assetJSON));

    return promise;
  }

  _setResults(results) {
    this.results = results;
    return (this.resultCount = results ? results.length : 0);
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }
};
